<template lang="pug">
.right_box_main
    .card-box
        .listBox
            .listBox-item 
                
                el-card 
                    // 进度列表第一级
                    .card_content(v-if="pageStep == 1 ")
                        el-form( :inline="true" :model="searchlist" class="demo-form-inline" size="mini")
                            el-form-item( label="巡视任务名称:" style="margin:0 30 0 0;") 
                                el-input(v-model='searchlist.name', placeholder='请输入')  
 
                            el-form-item(label='所属区域:'  )
                                el-cascader(ref='orgName',:props="cascaderProps" size='mini', v-model='searchlist.orgId', :options='cascaderData', :show-all-levels='false', placeholder='请选择所属网格', style='width:250px', clearable='',@change="cascaderChange" )
 

                            el-form-item( label="巡视人员:" style="margin:0 30 0 0;") 
                                el-input(v-model='searchlist.scanuser', placeholder='请输入')  
 
 
                            el-form-item
                                el-button(type='primary', @click='searchlistdata') 查询
                            el-form-item
                                el-button(type='info', @click='searchlistReset2') 重置

                        el-row.title-col(style='margin-bottom:10px;', type='flex', justify='space-between') 
                
                        el-table(ref='singleTable', :data='tableData',  size='mini', border='', align='center', current-row-key='', highlight-current-row='') 
                            el-table-column(align='center',minWidth='150', prop='name', label='巡视任务名称')
                            el-table-column(align='center',width='250', prop='content', label='巡视任务内容')  
                            el-table-column(align='center', width='150',prop="orgName", label='所属机构') 
                                     
                            el-table-column(align='center', width='150',prop="userName", label='巡查人员') 
                            el-table-column(align='center', width='150',prop="starttime", label='开始时间') 
                            el-table-column(align='center', width='150',prop="endtime", label='结束时间') 
                            el-table-column(align='center', width='150',prop="cnt", label='巡查进度') 
                            el-table-column(align='center', width='150',prop="scores", label='得分') 
                                      
                            el-table-column(align='center', label='操作', width='100', fixed='right')
                                template(slot-scope='scope')
                                    el-tooltip.item(effect='light', content='查看', placement='top-start')
                                        button.tabBtn.iconfont.icon-chakan(@click="gostepFunc(scope.row)",) 
 
                        el-pagination(@current-change='handleCurrentChange', :current-page='pageConfig.pageNo', :page-size='pageConfig.pageSize', layout='total, prev, pager, next, jumper', :total='pageConfig.total')

 
</template>

<script>
import { xcApi, OrgTreelist } from "@/api/http.js";
import { tabdata } from "@/mixins/tabledataMix.js";

export default {
  name: "networkPatrolJd",
  mixins: [tabdata],
  components: {},

  data() {
    return {
      pageStep: 1,
      cascaderProps: {
        value: "orgId",
        label: "label",
        children: "children",
        checkStrictly: true
      },
      cascaderData: [],
      pagetypes: 2,
      editDialog: {
        show: "",
        readonly: false,
        fatherdata: null,
        fatherid: null
      },

      timeArr: []
    };
  },
  filters: {},
  methods: {
    cascaderChange(val) {
      if (val && val.length) {
        if (val.length == 3) {
          this.searchlist.communityId = val[1];
          this.searchlist.gridId = val[2];
        } else if (val.length == 2) {
          this.searchlist.communityId = val[1];
          this.searchlist.gridId = "";
        }
      } else {
        this.searchlist.communityId = "";
        this.searchlist.gridId = "";
      }
    },
    gostepFunc(val) {
      //console.log(val)
      this.$router.push({ path: "networkPatrolJdPerson",query:{inspectionId:val.inspectionId,starttime:val.starttime,userId:val.userId} });
      //   this.pageStep = val;
      //   this.pageConfig.pageNo = 1;
      //   this.searchlistReset();
    },

    searchlistReset2() {
      this.timeArr = [];
      this.searchlistReset();
    },
    timeChange(val) {
      if (val) {
        this.searchlist.liveStartTime = val[0];
        this.searchlist.liveEndTime = val[1];
      } else {
        this.searchlist.liveStartTime = "";
        this.searchlist.liveEndTime = "";
      }
    },

    async OrgTreelist() {
      let res = await OrgTreelist({ orgType: 1 });
      // console.log(">>>>>>>>",res);
      if (!res.content) return;
      res.content[0].disabled = true;
      this.cascaderData = res.content;
    },
    async showDialog(row, flag) {
      this.flag = flag;

      if (row) {
        this.editDialog.fatherid = row.id || "";
        this.editDialog.fatherdata = JSON.parse(JSON.stringify(row));
      } else {
        this.editDialog = {
          show: "",
          readonly: false,
          fatherdata: null,
          fatherid: null
        };
      }

      switch (flag) {
        case "update":
          this.editDialog.readonly = false;
          this.editDialog.show = "add";

          break;

        case "add":
          this.editDialog.readonly = false;
          this.editDialog.show = "add";

          break;
        case "look":
          this.editDialog.readonly = true;
          this.editDialog.show = "add";

          break;

        // case "delete":
        //   this.$confirm("此操作将删除该活动, 是否继续?", "提示", {
        //     confirmButtonText: "确定",
        //     cancelButtonText: "取消",
        //     type: "warning"
        //   }).then(async () => {
        //     let deleteRes = await livelihoodsLiveStreamApi.delete({
        //       id: row.id
        //     });
        //     console.log(deleteRes);

        //     if (deleteRes.code == 200) {
        //       this.$message({
        //         type: "success",
        //         message: "删除成功"
        //       });
        //       this.getPageDatas();
        //       return;
        //     }
        //   });
        //   break;
      }
    },
    dialogReback(val) {
      if (val.dialog == "success") {
        this.getPageDatas();
      }
      this.editDialog = {
        show: "",
        readonly: false,
        fatherdata: null,
        fatherid: null
      };
    },
    // 超过3级,不能选中,子级分类最多4级
    /**
     * count: 当前层级
     * data: 当前层级的数据
     * maxNum: 最多不能超过几级
     */
    setDisable(count, data, maxNum) {
      if (count > maxNum) {
        //最多几级就写几
        data.forEach(v => {
          v.disabled = true; // 超过设定的最大级数,给这一集的数据添加disabled属性
        });
      } else {
        data.forEach(v => {
          v.count = count; // 设置最外层数据的初始count

          if (v.childs && v.childs.length) {
            v.count++;
            this.setDisable(v.count, v.childs, maxNum); // 子级循环时把这一层数据的count传入
          }
        });
      }
    }
  },
  mounted() {
    this.searchlist.type = this.pagetypes;
    this.initTableDataUrl(xcApi.getTableDataUrl);
    this.OrgTreelist();
  },
  created() {}
};
</script>

<style lang="less" scoped>
.icon-bianji3 {
  color: #2e99cf;
}
.icon-shenhe {
  color: #ff04ed;
}
.icon-chakan {
  color: #199b5d;
}
.card-box {
  float: left;
  width: 100%;
}
.mapBox {
  float: left;
  margin-left: 10px;
  width: 300px !important;
  height: 538px;
  background-color: rgb(252, 249, 242);
  div {
    width: 300px;
    height: 538px;
  }
}
.listBox {
  float: left;
  width: 100%;
}
.listBox-item {
  float: left;
  margin: 0 10px 10px 10px;
  width: calc(100% - 20px);
  overflow: auto;
  .el-card {
    height: 100%;
  }
  .left-img {
    width: 90%;
    margin-top: 13px;
  }
  .el-timeline {
    height: 230px;
    overflow: auto;
  }
}
.detailInfo {
  font-size: 14px;
  line-height: 2;
}
.tabBtn {
  margin: 0;
}
.title-col {
  position: relative;
  .el-dropdown {
    position: absolute;
    top: 67px;
    right: 18px;
    z-index: 99;
  }
}
.look-ul {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  margin-bottom: 20px;
}
.look-ul li {
  width: 28%;
  height: 30px;
  float: left;
}
.look-ul span {
  margin-left: 15px;
}
.look-ul1 {
  width: 60%;
  margin: 0 auto;
  overflow: hidden;
  margin-bottom: 20px;
}
.look-ul1 li {
  width: 50%;
  height: 30px;
  float: left;
}
.look-ul1 span {
  margin-left: 15px;
}
.personform {
  position: relative;
}
.personform .el-form-item {
  width: 36%;
}
.pic {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 170px;
  height: 180px;
  border: 1px solid #ccc;
}
.tc {
  float: right;
}
.dayincss {
  h2 {
    text-align: center;
    font-weight: 800;
    margin-bottom: 20px;
  }
  .twohang {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    span:first-child {
      box-sizing: border-box;
      padding-left: 100px;
      width: 650px;
    }
  }
}
.btit {
  width: 100%;
  padding-left: 15px;
  height: 28px;
  line-height: 28px;
  font-size: 14px;
  color: #888;
  box-sizing: border-box;
}
</style>
 